




































import {Vue, Component} from 'vue-property-decorator';
import dataProxy from '@/services/data-proxy.service'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {formatInteger, formatPrice} from "@/utils/formatters";
import {F_izv_TroskoviVozila} from "@/services/BackendProxies";
import * as _ from 'lodash'
import {red, blue} from '@/utils/colors';

@Component
export default class TroskoviPoVozilima extends mixins(ComponentBaseMixin) {
    dataSource: F_izv_TroskoviVozila[] = [];
    columns = [];
    chart1DataSource = {};
    chart2DataSource = {};
    chart3DataSource = {};
    chart4DataSource = {};
    chartOptions = {
        maintainAspectRatio: true,
        legend: {display: false},
    };

    async created() {
        this.columns = [
            {field: 'registarskaOznaka', title: this.$i18n.t('registarskaOznaka'), formatter:(registarskaOznaka, row) => `<a href='/#/detalji-vozila/${row.voziloId}'>${registarskaOznaka}</a>`},
            {field: 'markaIModel', title: this.$i18n.t('markaIModel'), footerFormatter: "UKUPNO"},
            {field: 'troskoviOdrzavanja', title: this.$i18n.t('troskoviOdrzavanja'), width: 120, align: 'right', formatter: formatPrice, sortable: true, footerFormatter: (data) => formatPrice(_.sumBy(data, 'troskoviOdrzavanja'))},
            {field: 'troskoviGoriva', title: this.$i18n.t('troskoviGoriva'), width: 120, align: 'right', formatter: formatPrice, sortable: true, footerFormatter: (data) => formatPrice(_.sumBy(data, 'troskoviGoriva'))},
            {field: 'ukupniTroskovi', title: this.$i18n.t('ukupniTroskovi'), width: 120, align: 'right', formatter: formatPrice, sortable: true, footerFormatter: (data) => formatPrice(_.sumBy(data, 'ukupniTroskovi'))},
            {field: 'ukupnaKilometraza', title: this.$i18n.t('ukupnaKilometraza'), width: 120, align: 'right', formatter: formatInteger, sortable: true, footerFormatter: (data) => formatPrice(_.sumBy(data, 'ukupnaKilometraza'))},
            {field: 'trosakPoKm', title: this.$i18n.t('trosakPoKm'), width: 120, align: 'right', formatter: formatPrice, sortable: true, footerFormatter: (data) => formatPrice(_.sumBy(data, 'ukupniTroskovi') / _.sumBy(data, 'ukupnaKilometraza'))},
        ];
        this.dataSource = await this.loadData(() => dataProxy.vratiTroskovePoVozilima())();
        this.setChart4DataSource();
        this.setChart3DataSource();
        this.setChart1DataSource();
        this.setChart2DataSource();
    }

    setChart1DataSource() {
        const top10 = _.take(this.dataSource.sort((a, b) => a.ukupniTroskovi > b.ukupniTroskovi ? -1 : 1), 10);
        this.chart1DataSource = {
            labels: top10.map(x => x.registarskaOznaka),
            datasets: [{backgroundColor: blue, data: top10.map(x => x.ukupniTroskovi)}]
        }
    }

    setChart2DataSource() {
        const top10 = _.take(this.dataSource.sort((a, b) => a.trosakPoKm > b.trosakPoKm ? -1 : 1), 10);
        this.chart2DataSource = {
            labels: top10.map(x => x.registarskaOznaka),
            datasets: [{backgroundColor: red, data: top10.map(x => x.trosakPoKm)}]
        }
    }

    setChart3DataSource() {
        const top10 = _.take(this.dataSource.sort((a, b) => a.troskoviGoriva > b.troskoviGoriva ? -1 : 1), 10);
        this.chart3DataSource = {
            labels: top10.map(x => x.registarskaOznaka),
            datasets: [{backgroundColor: red, data: top10.map(x => x.troskoviGoriva)}]
        }
    }

    setChart4DataSource() {
        const top10 = _.take(this.dataSource.sort((a, b) => a.troskoviOdrzavanja > b.troskoviOdrzavanja ? -1 : 1), 10);
        this.chart4DataSource = {
            labels: top10.map(x => x.registarskaOznaka),
            datasets: [{backgroundColor: blue, data: top10.map(x => x.troskoviOdrzavanja)}]
        }
    }

}
